module.exports = __webpack_public_path__ + "static/img/logo_head.aa6472e7.png";